"use strict";

exports.__esModule = true;
exports["default"] = exports.ProductText = exports.LegalBox = exports.ConsentBox = exports.CloseIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactWaypoint = _interopRequireDefault(require("react-waypoint"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CloseIcon = (0, _styledComponents["default"])(_components.NavClose).withConfig({
  displayName: "pkla__CloseIcon",
  componentId: "sc-1cdzt7w-0"
})(["width:24px;height:24px;fill:", ";position:absolute;top:24px;right:24px;cursor:pointer;"], function (props) {
  return (0, _styles.colors)("gray-dark", props);
});
exports.CloseIcon = CloseIcon;
var LegalBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "pkla__LegalBox",
  componentId: "sc-1cdzt7w-1"
})(["max-width:1180px;overflow:auto;color:", ";"], function (props) {
  return (0, _styles.colors)("body-grey", props);
});
exports.LegalBox = LegalBox;
var ConsentBox = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "pkla__ConsentBox",
  componentId: "sc-1cdzt7w-2"
})(["background-color:", ";border-radius:5px;"], function (props) {
  return (0, _styles.colors)("ultra-light-grey", props);
});
exports.ConsentBox = ConsentBox;
var ProductText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "pkla__ProductText",
  componentId: "sc-1cdzt7w-3"
})([""]);
exports.ProductText = ProductText;
var propTypes = {
  /**  Confirmation text for aggreeing to terms and conditions */
  agreeCopy: _propTypes.string.isRequired,

  /**  Current step in pkla progress chain */
  currentStep: _propTypes.number.isRequired,

  /**  Aggrement terms */
  legalCopy: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]).isRequired,

  /**  Aggree and continue on click callback */
  onClickAgree: _propTypes.func.isRequired,

  /**  Decline button on click callback */
  onClickDecline: _propTypes.func.isRequired,

  /**  Print version button on click callback */
  onClickPrintable: _propTypes.func.isRequired,

  /**  Text for the print/download cta */
  printCtaText: _propTypes.string,

  /**  Name of the PDP */
  product: _propTypes.string,

  /**  Title of the PKLA shown */
  title: _propTypes.string.isRequired,

  /**  Total number of pklas in progress chain */
  totalPkla: _propTypes.number.isRequired
};
var defaultProps = {
  printCtaText: "Printable version"
};

var PKLA = function PKLA(_ref) {
  var agreeCopy = _ref.agreeCopy,
      currentStep = _ref.currentStep,
      legalCopy = _ref.legalCopy,
      onClickAgree = _ref.onClickAgree,
      onClickDecline = _ref.onClickDecline,
      onClickPrintable = _ref.onClickPrintable,
      printCtaText = _ref.printCtaText,
      product = _ref.product,
      title = _ref.title,
      totalPkla = _ref.totalPkla;

  var _useState = (0, _react.useState)(true),
      checkboxDisabled = _useState[0],
      setCheckboxDisabled = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      isChecked = _useState2[0],
      setCheckboxChecked = _useState2[1];

  var enableCheckbox = function enableCheckbox() {
    if (checkboxDisabled) {
      setCheckboxDisabled(false);
    }
  };

  var checkboxChange = function checkboxChange() {
    if (!checkboxDisabled) {
      setCheckboxChecked(!isChecked);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    as: "section",
    flexDirection: "column",
    pt: 5
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Button, {
    onClick: onClickDecline
  }, /*#__PURE__*/_react["default"].createElement(CloseIcon, null)), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, {
    color: product ? "gray-dark" : "inherit",
    fontSize: product ? 8 : [8, 9],
    fontWeight: 2,
    letterSpacing: ["0.1px", "normal"],
    lineHeight: product ? 1 : [1.25, "normal"],
    mb: 3,
    tag: "h1",
    textAlign: "center",
    width: 1
  }, title), product && /*#__PURE__*/_react["default"].createElement(ProductText, {
    color: "gray-dark",
    fontSize: 3,
    fontWeight: 1,
    letterSpacing: "0.5px",
    mb: 3,
    textAlign: "center",
    width: 1
  }, product), totalPkla > 1 && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "center",
    mb: 4,
    mx: "auto",
    width: ["75%", "470px"]
  }, /*#__PURE__*/_react["default"].createElement(_components.ProgressIndicator, {
    progress: currentStep,
    steps: totalPkla
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    justifyContent: "center",
    mx: [3, "auto"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    glyphLeft: /*#__PURE__*/_react["default"].createElement(_components.NavDownload, null),
    letterSpacing: "0.5px",
    onClick: onClickPrintable,
    size: "small",
    version: "tertiary",
    width: [1, "auto"]
  }, printCtaText)), /*#__PURE__*/_react["default"].createElement(LegalBox, {
    height: "250px",
    mx: "auto",
    my: 4,
    px: [0, 3],
    width: ["calc(100% - 48px)", 1, 1, 5 / 6]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    pb: 2
  }, legalCopy), /*#__PURE__*/_react["default"].createElement(_reactWaypoint["default"], {
    bottomOffset: "-7px",
    onEnter: enableCheckbox
  }))), /*#__PURE__*/_react["default"].createElement(ConsentBox, {
    flexDirection: "column",
    justifyContent: "space-between",
    mb: [4],
    mx: [3, "auto"],
    p: [3],
    width: ["auto", "470px"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Checkbox, {
    checkboxOnChange: checkboxChange,
    disabled: checkboxDisabled,
    isChecked: isChecked,
    label: agreeCopy
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexDirection: ["column", "row"],
    justifyContent: "center",
    mx: [3, "auto"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    disabled: !isChecked,
    mb: [3, 1],
    mr: [0, 3],
    onClick: onClickAgree,
    width: [1, "auto"]
  }, "Agree and continue"), /*#__PURE__*/_react["default"].createElement(_components.Cta, {
    onClick: onClickDecline,
    version: "tertiary",
    width: [1, "auto"]
  }, "Decline")));
};

PKLA.defaultProps = defaultProps;
PKLA.propTypes = propTypes;
PKLA.displayName = "Modules.PKLA";
var _default = PKLA;
exports["default"] = _default;